import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../../user.service';
import {
  IUserFormUpdate,
  IUserTable,
  IUserUpdate,
  USER_TTL_ES
} from '../../../user.interface';
import { BranchStoreService } from '../../../../branch-stores/branch-store.service';
import { Subscription } from 'rxjs';
import { ROLES } from 'src/app/auth/interfaces/role.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';
import { UserChangePasswordService } from 'src/app/pages/users_change_password/users_change_password.service';

@Component({
  selector: 'pg-user-update',
  templateUrl: './user-update.component.html'
})
export class UserUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  changeForm = false;
  roles = ROLES;
  branchStores$: Subscription;
  allBranchStores = [];
  restartPassword;
  constructor(
    private fb: FormBuilder,
    private serviceBase: UserService,
    private branchStoreService: BranchStoreService,
    private userChangePasswordService: UserChangePasswordService
  ) {
    super(USER_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.restartPassword = false;
    const item = this.row as IUserTable;
    this.fg = this.fb.group({
      names: [
        item.names,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      surnames: [
        item.surnames,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      username: [
        item.username,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      restartPassword: [false, []],
      roleId: [item.roleId, [Validators.required]]
    });

    this.branchStores$ = this.branchStoreService
      .getData$()
      .subscribe((data) => {
        this.allBranchStores = data;
      });

    this.fg.valueChanges.subscribe(() => {
      this.changeForm = true;
    });
  }

  onSubmit() {
    const data = this.parseData(this.fg.value);
    this.updateItem$(data);
  }

  parseData(data: IUserFormUpdate) {
    const { restartPassword, ...fields } = data;
    const user: IUserUpdate = fields;
    if (restartPassword) {
      const payload = {
        userId: this.row.id,
        flag_change_password: 1
      };
      this.userChangePasswordService.register(payload);
      user.password = data.username;
    }
    return user;
  }
  checkRestart() {
    this.restartPassword = this.fg.value.restartPassword;
  }
  ngOnDestroy() {
    this.branchStores$.unsubscribe();
  }
}
